module.exports = __webpack_public_path__ + "img/im.8c10222d.svg";